import { render, staticRenderFns } from "./JoszakiUploadButton.vue?vue&type=template&id=252c3705"
import script from "./JoszakiUploadButton.vue?vue&type=script&lang=js"
export * from "./JoszakiUploadButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports